import React from "react";

const PanelTitle = ({ icon, children }) => (
  <h4>
    <img src={icon} alt="icon" /> {children}
  </h4>
);

export default PanelTitle;
